import SectionHeader from "../../../../components/SectionHeader/SectionHeader.tsx";
import type { DocumentType } from "../../../../types/lifecycle.ts";
import type { LifecycleController } from "../useLifecycle.ts";
import { CARD } from "./shared.tsx";
const labels: Record<DocumentType, string> = {
  policy: "Полица",
  "green-card": "Зелена карта",
  "payment-receipt": "Разписка",
  protocol: "Протокол",
  offer: "Оферта",
  terms: "Условия",
  report: "Справка",
};
const reasonTranslations: Record<string, string> = {
  "OZK exposes no standalone green-card print, and its specification does not say whether the green card is bundled into the policy PDF.":
    "Зелената карта е включена във файла на полицата.",
  "OZK's smetkaNomer is a number, not a document; there is no receipt PDF endpoint.":
    "Разписката е включена във файла на полицата.",
  "No protocol document in the OZK service.":
    "ОЗК не предоставя протокол за изтегляне.",
  "No offer document in the OZK service.":
    "ОЗК не предоставя оферта за изтегляне.",
  "No terms document in the OZK service.":
    "ОЗК не предоставя общите условия за изтегляне.",
  "No report document in the OZK service.":
    "ОЗК не предоставя справка за изтегляне.",
};
export function DocumentsPanel({
  controller,
}: {
  controller: LifecycleController;
}) {
  const { documents, busy, openDocument } = controller;
  if (!documents.length) return null;
  return (
    <fieldset className={CARD}>
      <SectionHeader title="Документи" />
      <div className="flex flex-col gap-2 p-3 pt-2">
        {documents.map((document) => (
          <div key={document.type} className="flex items-center gap-2 text-xs">
            <button
              type="button"
              disabled={!document.available || busy !== null}
              onClick={() => openDocument(document.type)}
              className="min-w-[130px] rounded bg-primary px-3 py-1 text-white disabled:opacity-40"
            >
              {labels[document.type]}
            </button>
            {!document.available && (
              <span>
                {reasonTranslations[document.reason ?? ""] ?? document.reason}
              </span>
            )}
            {document.oneShot && (
              <span className="text-danger">
                Достъпен само веднъж — запазете файла.
              </span>
            )}
          </div>
        ))}
      </div>
    </fieldset>
  );
}
